import { Lock } from 'lucide-react'
import { useState } from 'react'

import { Link } from '@/components/ui/Link'
import { ConfirmInfoModal } from './ConfirmInfoModal'

/** The application is locked once checkout is requested; changes go through a re-certified review. */
export function UpdateApplicationLink() {
  const [isReviewing, setIsReviewing] = useState(false)

  return (
    <>
      <Link
        kind="util"
        size="sm"
        icon={<Lock />}
        href="#"
        role="button"
        onClick={(event) => {
          event.preventDefault()
          setIsReviewing(true)
        }}
      >
        Update insurance application
      </Link>
      <ConfirmInfoModal open={isReviewing} onOpenChange={setIsReviewing} />
    </>
  )
}
